import { Theme } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import LightLogo from "../assets/DPL.svg";
import DarkLogo from "../assets/DPL_White.svg";
import darkTheme from "../util/DarkTheme";
import lightTheme from "../util/LightTheme";
import { useDarkMode } from "best-common-react";

type DplThemeContextType = {
  theme: Theme;
  appLogo: string;
  isDarkMode: boolean;
};

const DplThemeContextType = React.createContext<DplThemeContextType | undefined>(undefined);

const DplThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isDarkMode } = useDarkMode();
  const [theme, setTheme] = useState<Theme>(lightTheme);
  const [appLogo, setAppLogo] = useState<string>(LightLogo);

  useEffect(() => {
    const body = document.body;
    if (isDarkMode) {
      setTheme(darkTheme);
      setAppLogo(DarkLogo);
      body.style.background = darkTheme.palette.background.default;
      window.darkMode = true;
    } else {
      setTheme(lightTheme);
      setAppLogo(LightLogo);
      body.style.background = lightTheme.palette.background.default;
      window.darkMode = false;
    }
  }, [isDarkMode]);

  return <DplThemeContextType.Provider value={{ isDarkMode, appLogo, theme }}>{children}</DplThemeContextType.Provider>;
};

const useDplTheme = (): DplThemeContextType => {
  const context: DplThemeContextType | undefined = useContext(DplThemeContextType);
  if (context === undefined) {
    throw new Error(`useDplTheme must be used within a DplThemeProvider`);
  }
  return context;
};

export { DplThemeProvider, useDplTheme };
